import { z } from 'zod';
import type { JsonValue } from '@/db/schema';
import { parseJsonFieldWithValidation } from '@/lib/json-utils';
import { JsonSchema } from '../json/schemas';
import { parseOrDefault, parseOrNull } from '../schema';

const ReferencedTweetApiSchema = z.object({
  type: z.enum(['repliedTo', 'quoted', 'retweeted']),
  id: z.string(),
});

export const MediaArraySchema = z.array(
  z.object({
    media_key: z.string(),
    type: z.enum(['photo', 'video', 'animated_gif']),
    url: z.url().optional(),
    preview_image_url: z.url().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
    duration_ms: z.number().optional(),
    alt_text: z.string().optional(),
  })
);

export const ReferencedTweetsArraySchema = z.array(ReferencedTweetApiSchema);

export const JSONBFieldSchema = z.unknown().transform((value) =>
  parseJsonFieldWithValidation(
    // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion
    value as JsonValue | string | null | undefined,
    JsonSchema,
    // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion
    value as JsonValue | null | undefined
  )
);

export function validateJSONBField<T>(schema: z.ZodType<T>, data: unknown): T | null {
  return parseOrNull(schema, data);
}

export function extractMediaArray(data: unknown): Record<string, unknown>[] {
  return parseOrDefault(MediaArraySchema, data, []);
}

export function extractReferencedTweets(data: unknown): Record<string, unknown>[] {
  return parseOrDefault(ReferencedTweetsArraySchema, data, []);
}
